import * as Sentry from '@sentry/react';

import { deleteCookie, getCookie } from '@cast/utils';

import { COOKIE_KEYS } from 'core/cookies/constants';

import { CastAiWebCookie } from './types';

const castAiWebCookieDomain = () =>
  document.location.hostname === 'localhost' ? 'localhost' : '.cast.ai';

export const getCastAiWebCookie = (): CastAiWebCookie | undefined => {
  const cookieStr = getCookie(COOKIE_KEYS.CAST_AI_WEB_COOKIE);
  if (!cookieStr) {
    return;
  }
  try {
    return JSON.parse(decodeURIComponent(cookieStr));
  } catch (e) {
    console.error(e);
    Sentry.captureMessage(
      `CastAi web cookie was provided, but it was not a valid JSON. Cookie content: ${cookieStr}`
    );
    return undefined;
  }
  return undefined;
};

export const clearCastAiWebCookie = (): void => {
  deleteCookie({
    name: COOKIE_KEYS.CAST_AI_WEB_COOKIE,
    domain: castAiWebCookieDomain(),
  });
};
